import type { ComponentProps, FC } from 'react';
import { useForm } from 'react-formutil';
import FieldSelect from 'components/FieldSelect';
import FormItem from 'components/FormItem';
import { periodOptions } from './constants';
import { NextDepositDateTip } from './NextDepositDateTip';
import { PeriodTypeEnum } from './types';

interface DepositPeriodSelectProps extends Pick<ComponentProps<typeof FormItem>, 'label' | 'name'> {
    defaultValue?: string;
    /** 是否显示「无」选项 */
    supportNoneOption?: boolean;
    isIRA?: boolean;
}

/**
 * 定时入金时间周期选择组件，支持选择：每天、每周、每两周和每月
 */
const DepositPeriodSelect: FC<DepositPeriodSelectProps> = ({
    label,
    name = 'periodType',
    defaultValue,
    supportNoneOption,
    isIRA
}) => {
    const { $params } = useForm<{ periodType?: PeriodTypeEnum }>();
    const selectedValue = $params[name];

    const options = supportNoneOption
        ? periodOptions
        : periodOptions.filter(({ value }) => value !== PeriodTypeEnum.NONE);

    const placeholder = isIRA
        ? __('Please choose the recurring contribution frequency')
        : __('Please choose the recurring deposit frequency');

    return (
        <FormItem
            name={name}
            label={label}
            itemProps={{
                help: <NextDepositDateTip periodType={selectedValue} isIRA={isIRA} />
            }}
            $defaultValue={defaultValue || (supportNoneOption ? PeriodTypeEnum.NONE : PeriodTypeEnum.WEEK)}>
            <FieldSelect data={options} placeholder={placeholder} />
        </FormItem>
    );
};

export { PeriodTypeEnum, periodOptions };
export default DepositPeriodSelect;
